import BarcodeDetector from '@nico-martin/barcode-detector'

if (!('BarcodeDetector' in window)) {
    window.BarcodeDetector = BarcodeDetector;
}
